import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const GoBackButton = ({ backTo = '/', backText = 'Back' }) => {
  const navigate = useNavigate();
  return (
    <Button variant="outlined" color="primary" sx={{ mb: 2 }} onClick={() => navigate(backTo)}>
      {backText}
    </Button>
  );
};

export default GoBackButton;
